import React from 'react';
import { Box, CardContent, Typography, useTheme } from '@mui/material';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';

const JaiHind = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #000000, #000000)',
        padding: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 700,
          width: '100%',
          borderRadius: 3,
          padding: 4,
          backgroundColor: '#000000',
          color: '#ffffff',
          boxShadow: '0 8px 20px rgba(0,0,0,0.5)',
        }}
      >


        <CardContent>

          <Typography
            variant="h5"
            component="h1"
            sx={{
              fontWeight: 500,
              textAlign: 'center',
              fontSize: '2.5rem',
              backgroundImage: "linear-gradient(90deg, #FF9933, #FFFFFF, #138808)",

              backgroundClip: "text",

              color: 'transparent',
              letterSpacing: 6,

              marginBottom: '20px',

            }}
          >
            PROUD OF THE INDIAN ARMED FORCES
          </Typography>
          <Box sx={{ textAlign: 'center' }}>
            <img
              src="https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg"
              alt="Indian Flag"
              style={{ width: '75px', height: 'auto' }}
            />
          </Box>


          <Typography
            variant="body2"
            sx={{
              mt: 1,
              fontStyle: 'italic',
              fontSize: '3rem',
              letterSpacing: 1,
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
            }}
          >

            Jai Hind!

          </Typography>


          <Box sx={{ mt: 4, display: 'flex', }}>





          </Box>


        </CardContent>
      </Box>
    </Box>
  );
};

export default JaiHind;